



import { React, useState, useEffect, Component } from 'react';

import './App.css';
import './styles/global.css';
import { useTranslation } from 'react-i18next';

import LoginForm from './features/authentication/components/LoginForm';
import RegisterForm from './features/authentication/components/RegisterForm';
import { HashRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import Users from 'pages/Users';
import User from 'pages/User';
import AddUser from 'pages/AddUser';
import RoleList from 'pages/Roles/List';
import RoleCreate from 'pages/Roles/Create';
import RoleClaimListEdit from 'pages/Roles/EditRoleClaimList';
import AuthService from 'services/AuthService';
import authEventEmitter from 'utils/eventEmitter';
import Requests from 'pages/Requests/Requests';
import Request from 'pages/Requests/Request';
import CreateCodebook from 'pages/Codebooks/create';
import 'react-datepicker/dist/react-datepicker.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import CodebookList from 'pages/Codebooks/list';
import FileBrowser from 'components/FileBrowser';
import CodebookEdit from 'pages/Codebooks/edit';
import PasswordChange from 'pages/PasswordChange';
import { ToastContainer } from 'react-toastify';
import authService from 'services/AuthService';






const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(AuthService.isAuthenticated());


  useEffect(() => {
    const handleLogout = () => {
      console.log('Logout event received');
      setIsAuthenticated(false);
    };

    if (AuthService.isAuthenticated())
      setIsAuthenticated(true);

    authEventEmitter.on('logout', handleLogout);

    authEventEmitter.on('login', () => {
      setIsAuthenticated(true);
    });

    return () => {
      authEventEmitter.off('logout', handleLogout);
      authEventEmitter.off('login', () => {
      });
    };
  }, [isAuthenticated]);

  const { t } = useTranslation();
  const handleLogin = (email, password) => {
    console.log('Login attempt:', email, password, t('welcome'));
  };

  const handleRegister = (name, email, password) => {
    console.log('Registration attempt:', name, email, password);
  };

  //const isAuthenticated = AuthService.isAuthenticated();



  return (


    <div>
      <Router>
        {isAuthenticated && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              backgroundColor: '#2196f3',
              color: 'white',
              zIndex: 1000,
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            }}
          >
            <Navbar />
          </div>
        )}
        <div className="d-flex">
          {isAuthenticated && (
            <div style={{
              width: '250px',
              paddingTop: '20px',
              height: '100vh',
              position: 'fixed',
              top: '50px', // adjust based on navbar height
              //left: 10,
              backgroundColor: '#f4f4f4',
              borderRight: '1px solid #ccc',
              overflowY: 'auto',
              padding: '5px'
            }}>
              <Sidebar />
            </div>
          )}

          {/* Main Content Area */}
          <div
            className="container"
            style={{
              marginLeft: isAuthenticated ? '400px' : '0',
              paddingTop: '80px', // Space for fixed navbar
              paddingBottom: '80px',
              width: '100%',
              maxWidth: isAuthenticated ? 'calc(100% - 250px)' : '600px',
              marginRight: 'auto',
              marginLeft: isAuthenticated ? '250px' : 'auto',
            }}
          >
            <Routes>
              <Route path="/login" element={<LoginForm onLogin={handleLogin} />} />
              <Route path="/dashboard" element={isAuthenticated ? <Dashboard /> : <Navigate to="/login" replace />} />            <Route path="/register" element={<RegisterForm onRegister={handleRegister} />} />
              <Route path="/users" element={(isAuthenticated && authService.hasPermission('users_view')) ? <Users /> : <Navigate to="/login" replace />} />
              <Route path="/roles" element={(isAuthenticated && authService.hasPermission('roles_create')) ? <RoleList /> : <Navigate to="/login" replace />} />
              <Route path="/addrole" element={(isAuthenticated && authService.hasPermission('roles_create')) ? <RoleCreate /> : <Navigate to="/login" replace />} />

              <Route path="/role/claims/:roleId" element={(isAuthenticated && authService.hasPermission('roles_create')) ? <RoleClaimListEdit /> : <Navigate to="/login" replace />} />
              <Route path="/users/:identifier" element={isAuthenticated && authService.hasPermission('users_edit') ? <User /> : <Navigate to="/login" replace />} />
              <Route path="/adduser" element={isAuthenticated && authService.hasPermission('users_edit') ? <AddUser /> : <Navigate to="/login" replace />} />
              <Route path="/requests" element={isAuthenticated && authService.hasPermission('requests_list') ? <Requests /> : <Navigate to="/login" replace />} />
              <Route path="/requests/:identifier" element={isAuthenticated && authService.hasPermission('requests_view') ? <Request /> : <Navigate to="/login" replace />} />
              <Route path="/" element={isAuthenticated ? <Dashboard /> : <Navigate to="/login" replace />} />
              <Route path="/codebook/:codebookType" element={isAuthenticated && authService.hasPermission('codebooks_edit') ? <CodebookList /> : <Navigate to="/login" replace />} />
              {/* <Route path="/documents" element={isAuthenticated  ? <FileBrowser /> : <Navigate to="/login" replace />} /> */}

              <Route path="/codebook/:codebookType/adding" element={isAuthenticated && authService.hasPermission('codebooks_create') ? <CreateCodebook /> : <Navigate to="/login" replace />} />
              <Route path="/codebook/:codebookType/edit/:id" element={isAuthenticated && authService.hasPermission('codebooks_edit') ? <CodebookEdit /> : <Navigate to="/login" replace />} />
              <Route path="/reset-password" element={isAuthenticated ? <PasswordChange /> : <Navigate to="/login" replace />} />

              <Route path="*" element={<Navigate to="/login" replace />} />

            </Routes>

          </div>

        </div>
        <ToastContainer position="top-center" autoClose={3000} hideProgressBar />

      </Router>
    </div>

  );
};

export default App;
